import { createContext, useState,useMemo } from "react";
import { createTheme } from "@mui/material/styles";

export const colorMotifs = {
  blue: { label: "Blue", swatch: "#0b67b2", light: { main: "#0b67b2", dark: "#084f89", page: "#e8f3ff", paper: "#f8fbff", panel: "#d6eaff", panelStrong: "#b8d8f7", border: "#9bc7ee", nav: "#cfe7ff", navPanel: "#e6f2ff", text: "#0b3557", muted: "#416b8a" }, dark: { main: "#42a5f5", dark: "#1976d2", page: "#081827", paper: "#102a40", panel: "#183b5b", panelStrong: "#102f49", border: "#315b7d", nav: "#0b2236", navPanel: "#102f49", text: "#eaf4ff", muted: "#a9c7df" } },
  teal: { label: "Teal", swatch: "#087f8c", light: { main: "#087f8c", dark: "#05606a", page: "#e7f7f8", paper: "#f7fdfd", panel: "#d0eff1", panelStrong: "#afe1e5", border: "#86cbd1", nav: "#c9ecef", navPanel: "#e3f6f7", text: "#123f43", muted: "#477276" }, dark: { main: "#4dd0e1", dark: "#0097a7", page: "#071d20", paper: "#0d3035", panel: "#174c53", panelStrong: "#123e44", border: "#33747c", nav: "#09272b", navPanel: "#123e44", text: "#e5fbfc", muted: "#aad2d6" } },
  green: { label: "Green", swatch: "#2e7d32", light: { main: "#2e7d32", dark: "#1b5e20", page: "#edf7ed", paper: "#fbfefb", panel: "#dcefdc", panelStrong: "#c4e3c5", border: "#9bc99d", nav: "#d3ead4", navPanel: "#eaf6ea", text: "#19421c", muted: "#527455" }, dark: { main: "#66bb6a", dark: "#388e3c", page: "#0a1d0c", paper: "#123016", panel: "#1e4b23", panelStrong: "#183d1c", border: "#3f7343", nav: "#0d2710", navPanel: "#183d1c", text: "#eaf8eb", muted: "#b1d1b3" } },
  purple: { label: "Purple", swatch: "#7b1fa2", light: { main: "#7b1fa2", dark: "#5b147a", page: "#f5ecf9", paper: "#fdfafe", panel: "#ead7f2", panelStrong: "#d9bae7", border: "#c193d4", nav: "#e4cfed", navPanel: "#f2e7f7", text: "#452050", muted: "#75587d" }, dark: { main: "#ba68c8", dark: "#8e24aa", page: "#1b0b20", paper: "#2e1535", panel: "#492253", panelStrong: "#3b1b44", border: "#70427b", nav: "#24102a", navPanel: "#3b1b44", text: "#f8eafb", muted: "#d4b2da" } },
  rose: { label: "Rose", swatch: "#c2185b", light: { main: "#c2185b", dark: "#8e1242", page: "#fceef3", paper: "#fffafb", panel: "#f6d9e4", panelStrong: "#edbbce", border: "#dc91ae", nav: "#f2cfdd", navPanel: "#fae8ef", text: "#5b1d35", muted: "#86596a" }, dark: { main: "#f06292", dark: "#c2185b", page: "#210b13", paper: "#381522", panel: "#572238", panelStrong: "#461b2d", border: "#80435b", nav: "#2b101a", navPanel: "#461b2d", text: "#fdebf1", muted: "#deb5c4" } },
};

//Color design// color design tokens export
export const tokens = (mode) => ({
  ...(mode === "dark"
    ? {
        grey: {
          100: "#e0e0e0",
          200: "#c2c2c2",
          300: "#a3a3a3",
          400: "#858585",
          500: "#666666",
          600: "#525252",
          700: "#3d3d3d",
          800: "#292929",
          900: "#141414",
        },
        primary: {
          100: "#d0d1d5",
          200: "#a1a4ab",
          300: "#727681",
          400: "#1F2A40",
          500: "#141b2d",
          600: "#101624",
          700: "#0c101b",
          800: "#080b12",
          900: "#040509",
        },
        greenAccent: {
          100: "#dbf5ee",
          200: "#b7ebde",
          300: "#94e2cd",
          400: "#70d8bd",
          500: "#4cceac",
          600: "#3da58a",
          700: "#2e7c67",
          800: "#1e5245",
          900: "#0f2922",
        },
        redAccent: {
          100: "#f8dcdb",
          200: "#f1b9b7",
          300: "#e99592",
          400: "#e2726e",
          500: "#db4f4a",
          600: "#af3f3b",
          700: "#832f2c",
          800: "#58201e",
          900: "#2c100f",
        },
        blueAccent: {
          100: "#e3f2fd",
          200: "#bbdefb",
          300: "#90caf9",
          400: "#64b5f6",
          500: "#42a5f5",
          600: "#1e88e5",
          700: "#183b5b",
          800: "#102a40",
          900: "#081827",
        },
      }
    : {
        grey: {
          100: "#141414",
          200: "#292929",
          300: "#3d3d3d",
          400: "#525252",
          500: "#666666",
          600: "#858585",
          700: "#a3a3a3",
          800: "#c2c2c2",
          900: "#e0e0e0",
        },
        primary: {
          100: "#040509",
          200: "#080b12",
          300: "#0c101b",
          400: "#f2f0f0", // manually changed
          500: "#141b2d",
          600: "#1F2A40",
          700: "#727681",
          800: "#a1a4ab",
          900: "#d0d1d5",
        },
        greenAccent: {
          100: "#0f2922",
          200: "#1e5245",
          300: "#2e7c67",
          400: "#3da58a",
          500: "#4cceac",
          600: "#70d8bd",
          700: "#94e2cd",
          800: "#b7ebde",
          900: "#dbf5ee",
        },
        redAccent: {
          100: "#2c100f",
          200: "#58201e",
          300: "#832f2c",
          400: "#af3f3b",
          500: "#db4f4a",
          600: "#e2726e",
          700: "#e99592",
          800: "#f1b9b7",
          900: "#f8dcdb",
        },
        blueAccent: {
          100: "#084f89",
          200: "#d6eaff",
          300: "#b8d8f7",
          400: "#9bc7ee",
          500: "#64a8df",
          600: "#3389cb",
          700: "#1976d2",
          800: "#0b67b2",
          900: "#edf6ff",
        },
      }),
});

// mui theme settings
export const themeSettings = (mode, motifName = "blue") => {
  const colors = tokens(mode);
  const motif = (colorMotifs[motifName] || colorMotifs.blue)[mode];
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            // palette values for dark mode
            primary: {
              main: motif.main,
              contrastText: "#ffffff",
            },
            secondary: {
              main: colors.greenAccent[500],
            },
            neutral: {
              dark: colors.grey[700],
              main: colors.grey[500],
              light: colors.grey[100],
            },
            background: {
              default: motif.page,
              paper: motif.paper,
            },
          }
        : {
            // palette values for light mode
            primary: {
              main: motif.main,
              contrastText: "#ffffff",
            },
            secondary: {
              main: colors.greenAccent[500],
            },
            neutral: {
              dark: colors.grey[700],
              main: colors.grey[500],
              light: colors.grey[100],
            },
            background: {
              default: motif.page,
              paper: motif.paper,
            },
          }),
      motif,
    },
    typography: {
      fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 20,
      },
      h5: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 14,
      },
    },
    shape: { borderRadius: 10 },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: motif.page,
            color: motif.text,
          },
          "::-webkit-scrollbar-track": { background: motif.paper },
          "::-webkit-scrollbar-thumb": { background: motif.border, borderRadius: 8 },
        },
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: "none" } },
      },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 9, fontWeight: 700 },
          containedPrimary: { backgroundColor: motif.dark },
        },
      },
      MuiTableHead: {
        styleOverrides: { root: { backgroundColor: motif.panel } },
      },
      MuiDataGrid: {
        styleOverrides: {
          root: { backgroundColor: motif.paper },
          columnHeaders: { backgroundColor: motif.panel, color: motif.text },
        },
      },
      MuiTabs: {
        styleOverrides: { root: { backgroundColor: motif.panel }, indicator: { backgroundColor: motif.main, height: 3 } },
      },
    },
  };
};

// context for color mode
export const ColorModeContext = createContext({
  toggleColorMode: () => {},
  colorMotif: "blue",
  setColorMotif: () => {},
});

export const useMode = () => {
  const [mode, setMode] = useState("light");
  const [colorMotif, setColorMotifState] = useState(() => {
    const userID = sessionStorage.getItem("userID") || "default";
    const saved = localStorage.getItem(`businessJournal.colorMotif.${userID}`);
    return colorMotifs[saved] ? saved : "blue";
  });

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () =>
        setMode((prev) => (prev === "light" ? "dark" : "light")),
      colorMotif,
      setColorMotif: (motifName) => {
        const next = colorMotifs[motifName] ? motifName : "blue";
        const userID = sessionStorage.getItem("userID") || "default";
        localStorage.setItem(`businessJournal.colorMotif.${userID}`, next);
        setColorMotifState(next);
      },
    }),
    [colorMotif]
  );

  const theme = useMemo(() => createTheme(themeSettings(mode, colorMotif)), [mode, colorMotif]);
  return [theme, colorMode];
};
